import React, { useState, useEffect } from 'react';
import { useReducedMotion } from 'motion/react';
import AnimatedCursor from 'react-animated-cursor';
import { useSmoothScroll } from './hooks/useSmoothScroll';
import GrainOverlay from './components/ui/GrainOverlay';
import Navbar from './components/layout/Navbar';
import HeroSection from './components/sections/HeroSection';
import ProblemSection from './components/sections/ProblemSection';
import BentoGridSection from './components/sections/BentoGridSection';
import AllFeaturesSection from './components/sections/AllFeaturesSection';
import DemoVideoSection from './components/sections/DemoVideoSection';
import DeviceShowcaseSection from './components/sections/DeviceShowcaseSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import PricingSection from './components/sections/PricingSection';
import FAQSection from './components/sections/FAQSection';
import CTASection from './components/sections/CTASection';
import Footer from './components/layout/Footer';

function App() {
  useSmoothScroll();
  const prefersReducedMotion = useReducedMotion();
  const [isPointerFine, setIsPointerFine] = useState(false);

  useEffect(() => {
    // Only show custom cursor on devices with a fine pointer (mouse/trackpad)
    setIsPointerFine(window.matchMedia('(pointer: fine)').matches);
  }, []);

  const showCursor = isPointerFine && !prefersReducedMotion;

  return (
    <>
      {showCursor && (
        <AnimatedCursor
          innerSize={8}
          outerSize={35}
          color="249, 115, 22"
          outerAlpha={0.15}
          innerScale={0.7}
          outerScale={1.8}
          showSystemCursor={false}
          innerStyle={{ zIndex: 99999 }}
          outerStyle={{ zIndex: 99999 }}
          clickables={[
            'a',
            'button',
            'input',
            'textarea',
            'select',
            '.cursor-pointer',
            {
              target: '.card-glow',
              outerSize: 45,
              outerScale: 2,
            },
          ]}
        />
      )}
      <GrainOverlay />
      <Navbar />

      <main>
        {/* S1 — Hero + Trust Cities */}
        <HeroSection />

        {/* S2 — Problem + Solution + Metrics */}
        <ProblemSection />

        {/* S3 — Bento Grid Features */}
        <BentoGridSection />

        {/* S3c — Demo Video */}
        <DemoVideoSection />

        {/* S3b — All Features Deep Dive */}
        <AllFeaturesSection />

        {/* S4 — Device Showcase */}
        <DeviceShowcaseSection />

        {/* S5 — Testimonials */}
        <TestimonialsSection />

        {/* S5 — Pricing */}
        <PricingSection />

        {/* S6 — FAQ */}
        <FAQSection />

        {/* S7 — CTA + Steps */}
        <CTASection />
      </main>

      {/* S8 — Footer */}
      <Footer />
    </>
  );
}

export default App;
